import { render, staticRenderFns } from "./CustomerLabel.vue?vue&type=template&id=0b5c7551&scoped=true"
import script from "./CustomerLabel.vue?vue&type=script&lang=js"
export * from "./CustomerLabel.vue?vue&type=script&lang=js"
import style0 from "./CustomerLabel.vue?vue&type=style&index=0&id=0b5c7551&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c7551",
  null
  
)

export default component.exports